/**
 * ? @description : Overall View of Batches Data
 */

// Dependencies
import React, { useMemo, useState, useEffect } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  useTable,
  useRowSelect,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";

// CSS
import "../../../../css/grouptable.css";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";

// Axios Component
// import axios from "../../../../axios/Axios";

// Utils Components
import { BatchTableColumns } from "./group_table_utils/BatchTableColumns";
import { GlobalFilter } from "./group_table_utils/GlobalFilter";
// import { Checkbox } from "./group_table_utils/Checkbox";

// Modal Components
import TeacherModal from "./group_table_modal/TeacherModal";
import TeachersAttendanceStatusModal from "./group_table_modal/TeachersAttendanceStatusModal";
import CreateBatchesModal from "./group_table_modal/CreateBatchesModal";
import OverallBatchesData from "./group_table_modal/OverallBatchesData";
import DeleteBatch from "./group_table_modal/DeleteBatch";
import { CircularProgress } from "@mui/material";
import Axios from "../../../../axios/Axios";
import axios from "axios";

// import StudentModal from "./group_table_modal/StudentModal";
// import UpdateBatchModal from "./group_table_modal/UpdateBatchModal";

const GroupTable = () => {
  // * Redux Variable
  const dispatch = useDispatch();

  // * Batch Table Data
  const [batchTableData, setBatchTableData] = useState([]);

  // * Delete Batch Modal
  const [deleteBatchModal, setDeleteBatchModal] = useState(false);
  const [dataToDeleteBatchModal, setDataToDeleteBatchModal] = useState(null);

  // * Add Attendance Modal
  const [teacherAttendanceModal, setTeacherAttendanceModal] = useState(false);
  const [rowDataForAttendance, setRowDataForAttendance] = useState(null);

  // * Include & Exclude Teacher Modal
  const [dataToModel, setDataToModel] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  // * Include & Exclude Student Modal
  // const [dataToStudentModal, setDataToStudentModal] = useState(null);
  // const [studentModalShow, setStudentModalShow] = useState(false);

  // * Modal for Batch Update
  // const [batchModal, setBatchModal] = useState(false);
  // const [dataToBatchModal, setDataToBatchModal] = useState(null);

  // * Create Batch Modal
  const [createBatchModal, setCreateBatchModal] = useState(false);

  // * Overall Row Batches Details
  const [allBatchDataOpen, setAllBatchDataOpen] = useState(false);

  const [allBatchesData, setAllBatchesData] = useState([]);
  const [batchesDetails, setBatchesDetails] = useState("");
  const [attendanceStatus, setAttendanceStatus] = useState(null);
  // console.log(attendanceStatus);

  const [currentBatchName, setCurrentBatchName] = useState(null);
  // for reRender the page 
  const [reloadPage, setReloadPage] = useState(false);
  const handleAttendanceModalClose = () => {
    setReloadPage(!reloadPage);
  }

  const [isLoading, setIsLoading] = useState(false);

  // * Data Initializing for React-Table
  // const columns = useMemo(() => groupTableColumns, []);
  const columns = useMemo(() => BatchTableColumns, [])
  // console.log(columns);
  // const initialState = { hiddenColumns: ['Group Id'] , pageSize: 5};
  const data = useMemo(() => batchTableData, [batchTableData]);
  // console.log(columns);
  // ? API Call : Fetch data from the server and populate data to the table
  useEffect(() => {
    setIsLoading(true)
    const controller = axios.CancelToken.source();
    async function fetchBatchesDetails() {
      try {
        const options = {
          method: "get",
          url: "/batchview/batchtable",
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
          if (response.status === 200) {
            setBatchTableData(response.data)
            setIsLoading(false)
          }

      } catch (error) {
        if (!axios.isCancel(error)) {
          setIsLoading(false)
          dispatch(
            showSnackbar({
              message: "Error occurred! Unable to retrieve data.",
              severity: "error",
            })
          );
        }

      }
    }

    fetchBatchesDetails();
    return () => {
      controller.cancel();
    }
  }, [dispatch, reloadPage]);

  // ? API Request - Include & Exclude Teacher
  const batchTeachersButton = (row) => {
    setDataToModel(row.values);
    setModalShow(true);
  };

  // ? API Request - Add Attendance
  const teacherAttendace = async (row) => {
    const controller = axios.CancelToken.source();

    try {
      // console.log(row);
      const requestBody = {
        batch_id: row.values.batch_id,

      };

      const options = {
        method: "GET",
        url: `/batchview/teacherlist/batch/${requestBody.batch_id}`,
        auth: true,
        data: null,
        token:{cancelToken: controller.token}
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data,
        options.token,
        );
      // console.log(response.data);
      setRowDataForAttendance(response.data);

      setTeacherAttendanceModal(true);

    } catch (error) {
      if (!axios.isCancel(error)) {
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable to fetch data.",
            severity: "error",
          })
        );
        console.log(error)
      }

    }
    return () => {
      controller.cancel();
    }
  };

  // ? API Request - Include & Exclude Student
  // const batchStudentsButton = (row) => {
  //   console.log(row.values);
  //   console.log(row.values.batch_ids);
  //   const studentBatchId = await apiClient.get(`batchview/student/${row.values.batch_ids}`);
  //   setDataToStudentModal(row.values);
  //   setStudentModalShow(true);
  // };

  // ? API Request - Edit Method
  // const updateBatch = async (row) => {
  //   setDataToBatchModal(row.values);
  //   const updateResult = await apiClient.put(`/batches/${row.values.batch_ids}`);
  //   setBatchModal(true);
  // };

  // ? API Request - Delete Method
  const deleteBatch = (row) => {
    setDataToDeleteBatchModal(row.values.batch_id);
    setDeleteBatchModal(true);
  };

  // TODO : Create Batch Modal
  const createBatch = () => {
    setCreateBatchModal(true);
  };

  // ? API Call : View Overall Row Batch Details
  const rowBatchDetails = async (cell) => {
    const controller = axios.CancelToken.source();

    if (cell.column.id === "batch_name") {
      try {
        let options = {
          method: "get",
          url: `/batches/${cell.row.values.batch_id}`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );

        if (response.status === 200) {
          setBatchesDetails(response.data);
          setAllBatchesData(cell.row.values);
          setAllBatchDataOpen(true);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          dispatch(
            showSnackbar({
              message: "Error occurred! Unable to retrieve batch data.",
              severity: "error",
            })
          );
        }

      }
    } else {
      return null;
    }
    return () => {
      controller.cancel();
    }
  };

  // TODO : Customized Edit Button
  let tableHooks = (hooks) => {
    // console.log(hooks);
    hooks.visibleColumns.push((columns) => [
      // console.log(columns),
      ...columns,
      /* {
        id: "teacher_included",
        Header: "Teachers included",
        Cell: ({ row }) => {
          var teacherNames = row.original.teacher_included;
          teacherNames = teacherNames.join(", ");
          return <>{teacherNames}</>;
        },
      },
      {
        id: "teacher_profiles_count",
        Header: "Teacher profiles count",
        Cell: ({ row }) => {
          var teacherProfilesCount = row.original.teacher_profiles_count;
          return <>{teacherProfilesCount}</>;
        },
      },
      {
        id: "student_included",
        Header: "Students included",
        Cell: ({ row }) => {
          var studentNames = row.original.student_included;
          studentNames = studentNames.join(", ");
          return <>{studentNames}</>;
        },
      },
      {
        id: "Student_profiles_count",
        Header: "Student profiles count",
        Cell: ({ row }) => {
          var studentProfilesCount = row.original.Student_profiles_count;
          return <>{studentProfilesCount}</>;
        },
      }, */
      {
        id: "Action",
        Header: "Action",
        Cell: ({ row }) => {
          // console.log(row.original.attendance_status);
          return (
            <Dropdown className="dropdown">
              <Dropdown.Toggle
                variant="secondary rounded-circle"
                id="dropdown-basic"
              >
                <i className="bi bi-three-dots-vertical"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu >

                {row.original.attendance_status ? null : (
                  <Dropdown.Item
                    onClick={(e) => batchTeachersButton(row)}
                  >
                    Include & Exclude Volunteers
                  </Dropdown.Item>
                )}

                {/* <Dropdown.Item
                  href="#"
                  onClick={(e) => batchStudentsButton(row)}
                >
                  Include & Exclude Student
                </Dropdown.Item>

                <Dropdown.Item href="#" onClick={(e) => updateBatch(row)}>
                  Edit
                </Dropdown.Item> */}

                <Dropdown.Item onClick={(e) => {
                  // setAttendanceData(row.original);
                  setAttendanceStatus(row.original.attendance_status)
                  setCurrentBatchName(row.original.batch_name)
                  teacherAttendace(row)
                }}>
                  Add / View attendance
                </Dropdown.Item>

                {/* <Dropdown.Item href="#">
                  <AssignSpoc batchId={row.values.batch_id} batchName={row.values.batch_name}></AssignSpoc>
                </Dropdown.Item>

                <Dropdown.Item href="#">
                  Unassign SPOC
                </Dropdown.Item> */}

                <Dropdown.Item onClick={(e) => deleteBatch(row)}>
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        },
      },
    ]);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    // selectedFlatRows,
  } = useTable(
    {
      columns,
      data,
      initialState: { hiddenColumns: ['batch_id'], pageSize: 5 },

      // initialStateHidden

    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    tableHooks,
    useRowSelect
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => [
    //     {
    //       id: "selection",
    //       Header: ({ getToggleAllRowsSelectedProps }) => (
    //         <Checkbox {...getToggleAllRowsSelectedProps()} />
    //       ),
    //       Cell: ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />,
    //     },
    //     ...columns,
    //   ]);
    // }
  );

  const { pageIndex, pageSize, globalFilter } = state;

  // console.log(headerGroups);
  return (
    <>
      {/* <div>
        <h6 className="batch-header">BATCH</h6>
      </div> */}
      <div className="sec-table-filter">
        <div className="sec-table-left-filter">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        </div>

        <div className="sec-table-right-filter">
          <Button type="button" variant="primary" onClick={createBatch}>
            Create Batch
          </Button>
        </div>
      </div>

      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          
          
          {page.length !== 0 ? page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}  style={{
                cursor:'pointer'
              }}>
                {row.cells.map((cell) => {
                  // console.log(cell);
                  return (
                    <td
                      {...cell.getCellProps()}
                      onClick={() => {
                        rowBatchDetails(cell);
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          }) : isLoading ? ( // Assuming you have a loading state
            <tr>
              <td colSpan={7}>
                <CircularProgress />
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan={7}>No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="settings-pagination">
        <div className="settings-pagination-left">
          <span>
            Page -{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[5, 10, 15, 20].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="settings-pagination-right">
          <Button
            variant="light"
            className="settings-pagination-prev"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            First
          </Button>
          <Button
            className="settings-pagination-prev"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </Button>
          <Button
            className="settings-pagination-next"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </Button>
          <Button
            variant="light"
            className="settings-pagination-prev"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            Last
          </Button>
        </div>
      </div>

      {/* <div style={{
          textAlign: "center"
        }}>
          <h3>No groups created yet</h3>
      </div> */}

      {/* To Open Modal on Screen */}

      {/* Include & Exclude Teacher Modal */}
      <TeacherModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        datatomodal={dataToModel}
        onCloseCallBack={handleAttendanceModalClose}
      />

      {/* Include & Exclude Student Modal */}
      {/* <StudentModal
        show={studentModalShow}
        onHide={() => setStudentModalShow(false)}
        datatostudentmodal={dataToStudentModal}
      /> */}

      {/* Edit Modal */}
      {/* <UpdateBatchModal
        show={batchModal}
        onHide={() => setBatchModal(false)}
        datatobatchmodal={dataToBatchModal}
      /> */}

      {/* Create Batch Modal */}
      <CreateBatchesModal
        show={createBatchModal}
        onHide={() => setCreateBatchModal(false)}
        onCloseCallBack={handleAttendanceModalClose}
      />

      {/* Overall Batches Data */}
      <OverallBatchesData
        show={allBatchDataOpen}
        onHide={() => setAllBatchDataOpen(false)}
        allbatchesdata={allBatchesData}
        batchesdetails={batchesDetails}
      />

      {/* Add Attendance */}
      <TeachersAttendanceStatusModal
        open={teacherAttendanceModal}
        onClose={() => setTeacherAttendanceModal(false)}
        selectedRowData={rowDataForAttendance}
        attendanceData={batchTableData}
        onCloseCallBack={handleAttendanceModalClose}
        attendanceStatus={attendanceStatus}
        currentBatchName={currentBatchName}
      />

      {/* Delete Batch */}
      <DeleteBatch
        show={deleteBatchModal}
        onHide={() => setDeleteBatchModal(false)}
        datatodeletebatchmodal={dataToDeleteBatchModal}
        onCloseCallBack={handleAttendanceModalClose}
      />
    </>
  );
};

export default GroupTable;
